export default __webpack_public_path__ + "static/media/Newsletter 008.e6a6ac82.png";